import Link from "next/link";
import {NavItem, NavLink} from "reactstrap";
import React from "react";
import USER from "../../graphql/queries/user";
import {useQuery} from "@apollo/react-hooks";
import {getSessionId} from "../../services/session";
import withApollo from "../../lib/withApollo";
import {getDataFromTree} from "@apollo/react-ssr";

const CartMenuItem = () => {
    const sessionId = getSessionId();
    const {loading, error, data} = useQuery(USER, {
        variables: {
            uuid: sessionId
        }
    });

    return (
        <NavItem>
            <Link href='/favorieten' passHref>
                <NavLink>
                    <div className="position-relative">
                        <i className="large-tab-icon fas fa-heart"/>
                        {data && data.user && data.user.wishlist.productCount > 0 &&
                            <span className="notification-badge-desktop">{data.user.wishlist.productCount}</span>
                        }
                    </div>
                </NavLink>
            </Link>
        </NavItem>
    )
}

export default withApollo(CartMenuItem, {getDataFromTree});
